export default __webpack_public_path__ + "static/media/YOOZ-WEBSITE-AGENT-BANNER.2aa2e77b.png";